import { useEffect, useState } from "react";

export const useExtension = () => {
  const [isExtension, setIsExtension] = useState<boolean>();
  const [hash, setHash] = useState('')

  useEffect(() => {
    try {
        setIsExtension(typeof window !== 'undefined' &&
          (window.self !== window.top ||
            window.location.hash.startsWith('#/extension/')));
        if(window.location.hash.startsWith('#/extension/')){
          setHash(window.location.hash)
        }
    } catch {
        setIsExtension(false);
    }
  }, []);

  return {
    isExtension,
    hash
  }
}